<template>
  <div class="c-subject">
    <div>
    <span class="c-subject__header">学科分布</span>
    <div class="distribute">
      <div class="subject-distribute">
      </div>
      <div class="subject-num">
      <div class="subject-bg">
        <img src="../../images/radius-bg.png" alt="">
      </div>
      <div class="subject-circle">
      </div>
      <!-- <p class="test-num">智适应学生人数</p>
      <p class="test-total">{{studentNum}}</p> -->
      </div>
    </div>
    </div>

    <GradeDistribute v-bind="$attrs"/>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import GradeDistribute from './grade-distribute.vue';

export default {
  name: 'SubjectDistribute',
  props: {
    subjectList: {
      default: () => [],
      type: Array,
    },
    studentNum: {
      default: 0,
      type: Number,
    },
  },
  components: {
    GradeDistribute,
  },
  data() {
    return {
      colorOne: '',
      colorTwo: '',
    };
  },
  mounted() {
    // this.initCharts();
  },
  watch: {
    subjectList() {
      this.initCharts();
    },
  },
  computed: {
    arrList() {
      const arr = [];
      this.subjectList.forEach((item) => {
        if (item.subject_id === 2) {
          this.colorOne = '#ECFF48';
          this.colorTwo = '#FFE500';
        } else if (item.subject_id === 4) {
          this.colorOne = '#3EA5FF';
          this.colorTwo = '#1D6CFF';
        } else if (item.subject_id === 1) {
          this.colorOne = '#42F4FF';
          this.colorTwo = '#03C3DF';
        } else if (item.subject_id === 3) {
          this.colorOne = '#FDA76F';
          this.colorTwo = '#FA6E3C';
        } else if (item.subject_id === 5) {
          this.colorOne = '#E07FFF';
          this.colorTwo = '#BD49FF';
        } else {
          this.colorOne = '#00F1FF';
          this.colorTwo = '#8A4FFF';
        }
        arr.push({
          value: item.student_num,
          name: item.subject_name,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: this.colorOne,
              }, {
                offset: 1,
                color: this.colorTwo,
              }]),
            },
          },
        });
      });
      return arr;
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.subject-distribute'));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: ['39%', '49%'],
            center: ['49%', '43%'],
            labelLine: {
              length: 35,
              length2: 60,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // 自定义颜色
                  const res = `{name|${params.data.name}}`
                  + '\n\r'
                  + `{value|${params.data.value}个}`;
                  return res;
                },
                rich: {
                  name: {
                    fontSize: 20,
                    fontFamily: 'PingFangSC-Regular, PingFang SC',
                    fontWeight: 500,
                    color: '#fff',
                    lineHeight: 30,
                  },
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 18,
                    color: '#00DEFF',
                  },
                },
              },
            },
            data: this.arrList,
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-subject{
  box-sizing: border-box;
  width: 1062px;
  height: 404px;
  padding: 26px 40px 0 0;
  background: url('../../images/subject_bg.png') no-repeat ;
  background-size:100% 100%;
  display: flex;
   &__header {
     display: block;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        margin-left:46px ;
        color: #E3E2FF;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
  .distribute{
  position: relative;
  display: inline-block;
  .subject-distribute{
    width: 540px;
    height: 359px;
  }
   .subject-num{
      .subject-bg{
        width: 242px;
        height: 242px;
        position: absolute;
        top: 43%;
        left: 49%;
        transform: translate(-50%,-50%);
      }
      .subject-circle{
        width: 140px;
        height: 140px;
        position: absolute;
        top: 43%;
        left: 49%;
        transform: translate(-50%,-50%);
        background: #7DDCFF;
        opacity: 0.16;
        border-radius: 50%;
      }
      .test-num{
        position: absolute;
        top: 38%;
        left: 49%;
        transform: translate(-50%,-50%);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fff;
      }
      .test-total{
        position: absolute;
        top: 50%;
        left: 49%;
        transform: translate(-50%,-50%);
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
      }
    }
}
}
</style>
